//@ts-nocheck
import { useState } from 'react';
import type { NextPage } from 'next';
import Link from 'next/link';
import Image from 'next/image';
import { BailetsBlock } from '../../ModalCopy.styles';
import { CloseVideoIcon, LogoMartins } from '@assets/svgs';
import { CWriting } from '@data/copywriting';

type Nikejordan22Props = {
  isClosed?: () => void;
  showImg?: boolean | string;
  showMedia?: boolean | string;
};

export const Nikejordan22 = ({
  isClosed,
  showImg,
  showMedia
}: Nikejordan22Props) => {
  return (
    <>
      <BailetsBlock>
        <CloseVideoIcon
          animation="closeIcon"
          color="#000"
          isActive={isClosed}
        />
        <LogoMartins
          width={70}
          height={65}
          color="rgba(0,0,0,0.5)"
          animation="mansion"
        />

        <h3>NIKE</h3>
        <span style={{ marginBottom: '25px' }}>AIR JORDAN 22 - 2007</span>
        {showImg && <Image src={showImg} width={1480} height={825} alt="" />}
        {showMedia && (
          <video
            controlsList="nodownload"
            controls={true}
            playsInline
            muted
            autoPlay
            loop
          >
            <source src={showMedia} type="video/mp4" />
          </video>
        )}
        <h3 style={{ marginTop: '25px' }}>{CWriting.copyWriting[2].title1}</h3>
        <h3>{CWriting.copyWriting[2].title2}</h3>
        <p>
          <b>
            Silent yourself and then become a believer. WELCOME TO YOUR BIGNESS
            AND INFINITY.
          </b>
          <br />
          <br /> Step into the future of basketball with the Air Jordan 22. It's
          a masterful blend of cutting-edge technology and iconic heritage.
          Inspired by the sleek precision of the F-22 Raptor, this shoe is
          engineered for the elite. It features the revolutionary Independent
          Podular Suspension (I.P.S.) system, which provides unparalleled
          cushioning for every move and exceptional support for every jump.
          <br />
          <br />
          Feel the dual-layered heel absorb impact with every landing. While the
          high-top design and TPU heel counter provide unmatched stability.
          Whether you're driving to the hoop or dominating the streets, the Air
          Jordan 22 delivers the performance and style you need to stand out.
          <br />
          <br />
          Join the legacy of greatness. Experience the Air Jordan 22.
        </p>
      </BailetsBlock>

      <BailetsBlock>
        <h2 className="markTitle">Case Study: Launching the Air Jordan 22</h2>
        <p style={{ width: '100%' }}>
          <b>Brand:</b> Nike
          <br />
          <br />
          <b>Product:</b> Air Jordan 22
          <br />
          <br />
          <b>Objective:</b> Achieving Market Penetration and Consumer Engagement
          Amidst High Competition.
        </p>
      </BailetsBlock>

      <BailetsBlock style={{ justifyContent: 'center' }}>
        <h2 className="markTitle">Challenge</h2>
        <p style={{ width: '100%' }}>
          In 2007, Nike encountered the formidable task of unveiling the Air
          Jordan 22 amidst a fiercely competitive sneaker landscape. The market
          was teeming with brands and fresh releases, all clamouring for the
          attention of athletes, sneaker fans, and casual consumers.
          Furthermore, the challenge lay in upholding the illustrious legacy and
          esteemed reputation of the Air Jordan lineage while simultaneously
          integrating groundbreaking features. Nike was tasked with ensuring
          that the Air Jordan 22 not only distinguished itself but also
          resonated deeply with its varied audience, thereby solidifying its
          status as a preeminent force in sports footwear.
        </p>
      </BailetsBlock>

      <BailetsBlock style={{ justifyContent: 'center' }}>
        <h2 className="markTitle">Solution</h2>
        <p style={{ width: '100%' }}>
          <b>
            Strategic Marketing Campaign Combining Legacy, Innovation, and
            Consumer Engagement
          </b>
          <br />
          <br />
          To address these challenges, Nike developed a comprehensive marketing
          strategy that leveraged multiple channels and tactics. The solution
          focused on three main pillars: honoring the Air Jordan legacy,
          highlighting the innovative features of the Air Jordan 22, and
          engaging with the target audience through immersive experiences and
          influencer partnerships.
          <br />
          <br />
          <b>1. Honoring the Air Jordan Legacy</b>
          <br />
          Nike capitalized on the rich history and iconic status of the Air
          Jordan brand by creating a narrative that connected the Air Jordan 22
          to its predecessors. The campaign included:
          <br />
          <br />
          <b>1- Heritage Storytelling:</b> Nike produced a series of video
          content and social media posts that celebrated the evolution of the
          Air Jordan line. These stories highlighted key moments in Michael
          Jordan's career and showcased how each Air Jordan model contributed to
          his success.
          <br />
          <br />
          <b>2- Retrospective Events:</b> Nike hosted events in major cities
          that featured exhibits of previous Air Jordan models, allowing fans to
          experience the brand's history firsthand. These events included panel
          discussions with designers and former NBA players who discussed the
          impact of the Air Jordan series on basketball culture.
          <br />
          <br />
          <b>2. Highlighting Innovation</b>
          <br />
          To differentiate the Air Jordan 22, Nike emphasized its advanced
          technologies and unique design elements inspired by the F-22 Raptor
          fighter jet. Key initiatives included:
          <br />
          <br />
          <b>1- Technical Breakdown Videos:</b> Nike created detailed videos
          that explained the shoe's features, such as the Independent Podular
          Suspension (I.P.S.) system and the dual-layer heel. These videos were
          shared on social media and Nike’s website, making complex technical
          details accessible and engaging.
          <br />
          <br />
          <b>2- Influencer and Athlete Endorsements:</b> Nike collaborated with
          top NBA players and influencers who wore and reviewed the Air Jordan
          22. Their testimonials and endorsements highlighted how the shoe's
          technology enhanced their performance on the court.
          <br />
          <br />
          <b>3. Consumer Engagement</b>
          <br />
          Nike focused on creating immersive experiences that allowed consumers
          to interact with the Air Jordan 22 and build a personal connection
          with the brand. Strategies included:
          <br />
          <br />
          <b>1- Exclusive Launch Events:</b> Nike organized exclusive launch
          events where attendees could try on the Air Jordan 22, participate in
          basketball clinics, and meet professional athletes. These events
          generated buzz and provided firsthand experiences of the shoe's
          capabilities.
          <br />
          <br />
          <b>2- Interactive Digital Campaigns:</b> Nike developed interactive
          online campaigns where users could design their own Air Jordan 22
          colorways, share their creations on social media, and enter contests
          to win customized pairs. This user-generated content helped spread
          awareness and engagement organically.
        </p>
      </BailetsBlock>

      <BailetsBlock style={{ justifyContent: 'center' }}>
        <h2 className="markTitle">Results</h2>
        <p style={{ width: '100%' }}>
          The strategic marketing campaign for the Air Jordan 22 resulted in
          several positive outcomes:
          <br />
          <b>1- Strong Sales Performance:</b> The Air Jordan 22 achieved
          impressive sales figures, surpassing initial projections and
          solidifying its place in the market despite stiff competition.
          <br />
          <br />
          <b>2- Enhanced Brand Loyalty:</b> By honoring the legacy of the Air
          Jordan line and engaging consumers through innovative and interactive
          experiences, Nike strengthened brand loyalty among existing fans and
          attracted new customers.
          <br />
          <br />
          <b>3- Increased Market Visibility:</b> The campaign's multifaceted
          approach, including influencer partnerships and exclusive events,
          increased the visibility of the Air Jordan 22 across various media
          platforms, driving consumer interest and awareness.
        </p>
      </BailetsBlock>

      <BailetsBlock style={{ justifyContent: 'center' }}>
        <h2 className="markTitle">Conclusion</h2>
        <p style={{ width: '100%' }}>
          Nike's launch of the Air Jordan 22 serves as a successful case study
          in navigating market challenges through a well-rounded strategy that
          honors brand legacy, highlights innovation, and actively engages
          consumers. By addressing these key areas, Nike not only reinforced the
          Air Jordan brand's prestigious status but also set a benchmark for
          future sneaker launches in a competitive market.
        </p>
      </BailetsBlock>
    </>
  );
};
